export default __webpack_public_path__ + "static/media/404.5c737d7e.png";